import React from 'react';

import ErrorIcon from '@mui/icons-material/Error';

import { SIGN_UP_ERROR_TEXT } from '../../../constants/Surveys';

import './SignUpWithEmailError.css';

export const SignUpWithEmailError = () => {
  return (
    <div className="sign-up-email-error-wrapper">
      <ErrorIcon /> <div className="sign-up-email-text-wrapper">{SIGN_UP_ERROR_TEXT}</div>
    </div>
  );
};
